import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import Social from 'entity/Social';
import { BaseUser } from 'messages/websocket.messages';

import { SceneService } from '../../services/scene.service';
import { Player } from '../../social-pixi-canvas/player';
import SocialStateMachine from '../../social-state-machine/social-state-machine';
import { socialAppSelectors } from '../../state/app';

@Component({
  selector: 'app-guests-list',
  templateUrl: './guests-list.component.html',
  styleUrls: ['./guests-list.component.scss'],
  standalone: false,
})
export class GuestsListComponent extends Loggable implements OnInit, OnDestroy {
  public social?: Social;
  public guests: Player[] = [];
  public waitingUsers: BaseUser[] = [];
  public waitingUsersUids: string[] = [];
  public filteredGuests: Player[] = [];
  public searchValue = '';
  public isHost = false;
  public panelIndicator?: boolean;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private sceneService: SceneService,
    private store: Store,
  ) {
    super();
    this.store
      .select(socialAppSelectors.isHost)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isHost) => (this.isHost = isHost));

    this.store
      .select(socialAppSelectors.getCurrentSocial)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((social) => (this.social = social));
  }

  public ngOnInit(): void {
    SocialStateMachine.shared.stateChanged$.pipe(takeUntil(this.destroyed$)).subscribe((state) => {
      this.waitingUsers = state.readOnly.waitingUsers ? Object.values(state.readOnly.waitingUsers) : [];
      this.waitingUsersUids = state.readOnly.waitingUsers ? Object.keys(state.readOnly.waitingUsers) : [];
    });

    this.guests = this.sceneService?.sceneManager?.participantsAndPlayerList ?? [];
    this.filteredGuests = [...this.guests.sort(this.compare)];

    this.sceneService?.sceneManager?.participantsCountChange.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.guests = this.sceneService?.sceneManager?.participantsAndPlayerList ?? [];
      this.filteredGuests = [...this.guests];
      this.filterParticipants();
    });
  }

  /**
   * @deprecated - what is this?
   */
  protected manageAllWaitingUsers(a: boolean, b: boolean): void {
    this.logger.info(`a b ${a} ${b}`);
  }

  public filterParticipants(): void {
    this.filteredGuests = this.guests
      .filter(({ user }) => {
        const { firstName, lastName } = user;
        const searchValue = this.searchValue.trim().toLowerCase();

        return (
          firstName?.toLowerCase().includes(searchValue) || lastName?.toLowerCase().includes(searchValue.toLowerCase())
        );
      })
      .sort(this.compare);
  }

  private compare(a: Player, b: Player): number {
    const nameA = a.user?.firstName?.toUpperCase();
    const nameB = b.user?.firstName?.toUpperCase();
    let comparison = 0;
    if (!nameA) {
      return -1;
    }
    if (!nameB) {
      return 1;
    }
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
